import React from 'react';
import { TAX_RATES_QUERY } from '../queries';
import TaxRateListContainer from './TaxRateListContainer';
import ListBrowser, { getListBrowserStore } from '@ts-private/list-browser';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { useMemo } from 'react';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';

export const taxRatesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'TaxRate.Code',
      type: 'text'
    },
    {
      name: 'description',
      caption: 'TaxRate.Description',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'TaxRate.Code',
      value: 'Code'
    },
    {
      caption: 'TaxRate.Description',
      value: 'Description'
    }
  ],
  pager: {
    orderBy: 'Code',
    direction: 'asc'
  }
});

const TaxRateListBrowser = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: TAX_RATES_QUERY,
        name: 'taxRates'
      }
    }),
    []
  );

  return (
    <>
      <ListBrowser name='TaxRate-browser' store={taxRatesStore} ItemsComponent={TaxRateListContainer} />
      <ExportModalComponent store={taxRatesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={taxRatesStore} options={fetchingOptions} />
    </>
  );
};

export default TaxRateListBrowser;
